import Button from "../button";
import { Pencil } from "../../assets/icons";

/**
 * Ligne paramètres : titre 14px, description, bouton modifier (modal).
 */
export function SettingRow({ title, description, onEdit }) {
  return (
    <div className="border-b border-gray-100 last:border-b-0">
      <div className="flex items-start justify-between gap-3 px-5 py-4 transition-colors hover:bg-gray-50 sm:px-6">
        <div className="min-w-0 flex-1 space-y-1">
          <h3 className="text-sm font-semibold leading-snug text-gray-900">
            {title}
          </h3>
          {description ? (
            <div className="text-sm leading-relaxed text-gray-500">
              {description}
            </div>
          ) : null}
        </div>
        <Button
          color="SECONDARY"
          size="SMI"
          onClick={onEdit}
          name="settings_row_edit"
          aria-label="Modifier"
        >
          <Pencil wh={18} color="#374151" />
        </Button>
      </div>
    </div>
  );
}
